export default "__VITE_ASSET__CFvJ7bn$__"